'use client';

import { useState, useEffect } from 'react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

interface FooterProps {
  className?: string;
}

const Footer = ({ className = '' }: FooterProps) => {
  const [isHydrated, setIsHydrated] = useState(false);
  const [currentYear, setCurrentYear] = useState('2026');

  useEffect(() => {
    setIsHydrated(true);
    setCurrentYear(new Date().getFullYear().toString());
  }, []);

  const socialLinks = [
    { name: 'WhatsApp', icon: 'ChatBubbleLeftEllipsisIcon', href: '#' },
    { name: 'Telegram', icon: 'PaperAirplaneIcon', href: '#' },
    { name: 'Instagram', icon: 'CameraIcon', href: '#' },
  ];

  if (!isHydrated) {
    return (
      <footer className={`border-t border-border bg-card ${className}`}>
        <div className="mx-auto max-w-7xl px-4 py-12 lg:px-6">
          <div className="flex items-center justify-center">
            <div className="mb-4 h-5 w-24 rounded bg-muted" />
          </div>
        </div>
      </footer>
    );
  }

  return (
    <footer className={`border-t border-border bg-card ${className}`}>
      <div className="mx-auto max-w-7xl px-4 py-12 lg:px-6 lg:py-16">
        <div className="flex flex-col items-center justify-center text-center">
          <Link
            href="/homepage"
            className="mb-4 flex items-center gap-2 transition-transform duration-250 hover:scale-105 focus:outline-none focus:ring-2 focus:ring-accent focus:ring-offset-2"
          >
            <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="text-primary-foreground"
              >
                <path
                  d="M3 9L12 2L21 9V20C21 20.5304 20.7893 21.0391 20.4142 21.4142C20.0391 21.7893 19.5304 22 19 22H5C4.46957 22 3.96086 21.7893 3.58579 21.4142C3.21071 21.0391 3 20.5304 3 20V9Z"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M9 22V12H15V22"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <span className="font-heading text-xl font-bold text-primary">
              Optovichok.kz
            </span>
          </Link>
          <p className="mb-6 max-w-md text-sm leading-relaxed text-text-secondary">
            Оптовые поставки товаров народного потребления по всему Казахстану
          </p>
          <div className="mb-8 flex items-center gap-3">
            {socialLinks.map((social) => (
              <a
                key={social.name}
                href={social.href}
                className="flex h-10 w-10 items-center justify-center rounded-md bg-muted text-text-primary transition-all duration-250 hover:bg-primary hover:text-primary-foreground focus:outline-none focus:ring-2 focus:ring-accent focus:ring-offset-2"
                aria-label={social.name}
              >
                <Icon name={social.icon as any} size={20} />
              </a>
            ))}
          </div>
        </div>
        
        <div className="mt-8 border-t border-border pt-8">
          <div className="flex flex-col items-center justify-between gap-4 sm:flex-row">
            <p className="font-caption text-sm text-text-secondary">
              &copy; {currentYear} Optovichok.kz. Все права защищены.
            </p>
            <div className="flex items-center gap-6">
              <Link
                href="/homepage"
                className="font-caption text-sm text-text-secondary transition-colors duration-250 hover:text-accent focus:outline-none focus:ring-2 focus:ring-accent focus:ring-offset-2"
              >
                Политика конфиденциальности
              </Link>
              <Link
                href="/homepage"
                className="font-caption text-sm text-text-secondary transition-colors duration-250 hover:text-accent focus:outline-none focus:ring-2 focus:ring-accent focus:ring-offset-2"
              >
                Условия использования
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;